import type { ReactNode } from 'react'

import { cn } from '../cn.js'

export interface EmptyStateProps {
  title: string
  description: string
  /** Decorative icon (hidden from assistive technology). */
  icon?: ReactNode
  action?: ReactNode
  /** Heading level of the title within the page outline. */
  headingLevel?: 1 | 2 | 3
  className?: string
}

/** Placeholder for a page or section without content: heading, description, optional action. */
export function EmptyState({
  title,
  description,
  icon,
  action,
  headingLevel = 2,
  className,
}: EmptyStateProps) {
  const Heading = `h${String(headingLevel)}` as 'h1' | 'h2' | 'h3'
  return (
    <section
      className={cn(
        'flex flex-col items-center gap-3 rounded-[20px] border border-dashed border-line bg-surface px-6 py-12 text-center',
        className
      )}
    >
      {icon !== undefined && (
        <span aria-hidden="true" className="text-muted">
          {icon}
        </span>
      )}
      <Heading className="m-0 font-display text-xl font-bold tracking-tight">{title}</Heading>
      <p className="m-0 max-w-prose text-muted">{description}</p>
      {action}
    </section>
  )
}
